import { intimateAnalysis } from "@/mocks/lustCaution";

export default function Intimate() {
  return (
    <section id="intimate" className="w-full bg-primary-950 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-2/5">
              <p className="text-accent-400 font-label text-sm tracking-widest uppercase">Interpretation</p>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-background-50 leading-snug">
                情欲戏，为什么是删减的核心
              </h2>
              <p className="mt-5 text-background-200/80 leading-relaxed">
                很多人把这几场戏理解成「尺度」，但在影片的结构里，它们更像三段无声的对话。
                台词在这里是失效的，人物只能用距离、姿态与攻守来完成交流。
              </p>

              <div className="mt-8 rounded-lg overflow-hidden border border-background-50/15 w-full h-56 md:h-72">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20still%20life%20in%20deep%20crimson%20velvet%20and%20candlelight%2C%20folded%20silk%20fabric%20and%20soft%20shadows%2C%20painterly%20vintage%20cinematic%20aesthetic%2C%20moody%20warm%20color%20palette%2C%20elegant%20and%20restrained%2C%20no%20text%2C%20no%20people&width=800&height=1000&seq=lust-intimate-01&orientation=portrait"
                  alt="深红丝绒与烛光氛围的抽象艺术配图"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:w-3/5 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 content-start">
              {intimateAnalysis.map((item, i) => (
                <div
                  key={item.title}
                  className="rounded-lg bg-background-50/5 border border-background-50/15 p-5 md:p-6"
                >
                  <span className="font-heading text-accent-400 text-sm">0{i + 1}</span>
                  <h3 className="mt-2 font-heading text-lg md:text-xl font-semibold text-background-50 leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm text-background-200/80 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}